enum AppPlatform {
  ASH = "ASH",
  EMBARK = "EMBARK",
  MYDOCS = "MYDOCS",
}

export default AppPlatform;
